export default function Header(el) {
	const menuBtn = el.querySelector('.header__menu-btn');
	
	menuBtn.addEventListener('click', () => {
		el.classList.toggle('header--open');
	});
}
